var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "39px",
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/services/apple music") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/services/apple-music",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "apple"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#F8F8F8",
    cx: 19.5,
    cy: 19.5,
    r: 19.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Apple_Store_logo",
    transform: "translate(11.634454, 9.176471)",
    fill: "#3C3C3C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.82067827,4.55717581 C8.22839135,4.55717581 9.55037014,4.29852528 10.5758303,2.80820564 C11.4530312,1.51495304 11.3541917,0.0739001483 11.3541917,0.0739001483 C11.3541917,0.0739001483 9.83453381,-0.0369500741 8.50020008,1.61348657 C7.53651461,2.82052232 7.61064425,4.54485911 7.61064425,4.54485911 C7.61064425,4.54485911 7.68477391,4.55717581 7.82067827,4.55717581 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4436775,14.0287115 C15.5178071,13.8193277 15.5672269,13.6961608 15.5672269,13.6961608 C15.5672269,13.6961608 15.5672269,13.6961608 15.5548719,13.6961608 C15.5548719,13.6961608 15.542517,13.6961608 15.5301621,13.6838441 C15.4560324,13.6592107 15.2830632,13.5853106 15.0606743,13.4498269 C14.6158963,13.1911765 13.9981492,12.7108255 13.5533714,11.934874 C13.2692077,11.4422063 13.0715286,10.8263717 13.0221089,10.0627369 C12.9973989,9.68091943 13.0344638,9.31141868 13.1085934,8.97886801 L13.1085934,8.96655131 C13.1333033,8.85570112 13.1580132,8.75716758 13.195078,8.64631735 C13.5904361,7.36538145 14.5170569,6.52784644 14.8877051,6.24456253 C14.9865447,6.17066237 15.0359644,6.1337123 15.0359644,6.1337123 C15.0359644,6.1337123 13.84989,4.29852528 11.6136455,4.29852528 C9.68627451,4.29852528 8.96968787,5.1606937 7.94422768,5.1606937 C6.6840236,5.1606937 6.48634453,4.36010874 4.6207483,4.36010874 C3.65706282,4.36010874 2.31037415,4.72960949 1.30962385,6.02286209 C0.518907564,7.03283079 0.222388957,8.22754984 0.0988395358,9.10203493 C0.024709884,9.69323613 -5.54070678e-15,10.3337041 0.0741296518,11.0480722 C0.0741296518,11.0973389 0.0864845938,11.1466057 0.0864845938,11.2081892 C0.160614246,11.9225573 0.345938376,12.6861922 0.605392156,13.4498269 C0.605392156,13.4621437 0.617747099,13.4867771 0.630102042,13.4990938 C0.654811925,13.5853106 0.69187675,13.6838441 0.728941577,13.7700609 C0.741296518,13.807011 0.766006402,13.8562779 0.778361344,13.8932279 C0.790716288,13.930178 0.803071229,13.9794447 0.827781112,14.0163948 C1.07487995,14.6568628 1.35904361,15.2726973 1.69262705,15.8515818 C2.65631254,17.5512852 3.90416167,18.8322212 5.07788114,18.8322212 C6.41221489,18.8322212 6.83228291,17.9700528 8.16661665,17.9823694 C9.8592437,17.994686 10.3287315,19.0662382 11.7495498,18.7829544 C12.7008804,18.5982039 13.837535,17.2556847 14.5664766,15.9747488 C14.5911865,15.9254819 14.6158963,15.8885319 14.6406063,15.8515818 C14.9865447,15.1125804 15.2830632,14.4228456 15.4436775,14.0287115 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d76eaae6df81875d73fa8b0f08986494.svg";
export { ForwardRef as ReactComponent };